import { render, staticRenderFns } from "./detailed_view.vue?vue&type=template&id=6ff5aa76&"
import script from "./detailed_view.vue?vue&type=script&lang=js&"
export * from "./detailed_view.vue?vue&type=script&lang=js&"
import style0 from "./detailed_view.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports